export default __webpack_public_path__ + "static/media/Moola.4b46c528.jpeg";